import { Component } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'app';
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/app.component.ts